import { produce } from 'immer';
import _ from 'lodash';

import { PushNotificationConnectionStatus } from 'constants/pushNotifications';

import { PUSH_NOTIFICATIONS_ACTION_TYPE } from '../actions';

const initialState = {
  items: [],
  nextCursor: null,
  hasMore: true,
  unreadCount: 0,
  totalCount: 0,
  connectionStatus: PushNotificationConnectionStatus.DISCONNECTED,
  filters: {
    type: null,
    source: null,
  },
};

const findNotificationIndex = (items, notificationId) =>
  items.findIndex(item => item.id === notificationId);

const pushNotificationsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case PUSH_NOTIFICATIONS_ACTION_TYPE.GET_STATISTICS:
        draft.unreadCount = payload.unreadCount;
        draft.totalCount = payload.totalCount;
        break;

      case PUSH_NOTIFICATIONS_ACTION_TYPE.MARK_ALL_READ_PENDING:
        draft.items.forEach(item => {
          if (_.isNil(item.readDate)) {
            item.readDate = new Date().toISOString();
          }
        });
        draft.unreadCount = 0;
        break;

      case PUSH_NOTIFICATIONS_ACTION_TYPE.MARK_ALL_READ_REJECTED:
        draft.items = payload.previousItems;
        draft.unreadCount = payload.previousUnreadCount;
        break;

      case PUSH_NOTIFICATIONS_ACTION_TYPE.FETCH_NOTIFICATIONS: {
        draft.nextCursor = payload.nextCursor;
        draft.hasMore = payload.hasMore;
        draft.unreadCount = payload.unreadCount;

        draft.items = meta?.isLoadMore ? [...state.items, ...payload.items] : payload.items;

        break;
      }

      case PUSH_NOTIFICATIONS_ACTION_TYPE.NOTIFICATION_RECEIVED: {
        const notification = payload;

        draft.items.unshift(notification);

        if (_.isNil(notification.readDate)) {
          draft.unreadCount += 1;
        }

        break;
      }

      case PUSH_NOTIFICATIONS_ACTION_TYPE.MARK_READ_PENDING: {
        const { notificationId } = payload;
        const itemIndex = findNotificationIndex(draft.items, notificationId);

        if (itemIndex >= 0 && _.isNil(draft.items[itemIndex].readDate)) {
          draft.items[itemIndex].readDate = new Date().toISOString();
          draft.unreadCount = Math.max(0, draft.unreadCount - 1);
        }

        break;
      }

      case PUSH_NOTIFICATIONS_ACTION_TYPE.MARK_READ_REJECTED: {
        const { notificationId, previousReadDate, previousUnreadCount } = payload;
        const itemIndex = findNotificationIndex(draft.items, notificationId);

        if (itemIndex >= 0) {
          draft.items[itemIndex].readDate = previousReadDate;
        }

        draft.unreadCount = previousUnreadCount;

        break;
      }

      case PUSH_NOTIFICATIONS_ACTION_TYPE.TOGGLE_IMPORTANT_OPTIMISTIC:

      case PUSH_NOTIFICATIONS_ACTION_TYPE.TOGGLE_IMPORTANT_ROLLBACK: {
        const { notificationId, isImportant } = payload;
        const itemIndex = findNotificationIndex(draft.items, notificationId);

        if (itemIndex >= 0) {
          draft.items[itemIndex].isImportant = isImportant;
        }

        break;
      }

      case PUSH_NOTIFICATIONS_ACTION_TYPE.SET_CONNECTION_STATUS:
        draft.connectionStatus = payload;
        break;

      case PUSH_NOTIFICATIONS_ACTION_TYPE.SET_FILTER: {
        const { type: filterType, source } = payload;

        if (filterType !== undefined) {
          draft.filters.type = filterType;
        }

        if (source !== undefined) {
          draft.filters.source = source;
        }

        draft.items = [];
        draft.nextCursor = null;
        draft.hasMore = true;
        break;
      }

      default:
        return state;
    }
  });

export default pushNotificationsReducer;
